import { useEffect, useState, useRef } from 'react';
import { IonModal, IonIcon, IonImg, IonGrid, IonRow, IonCol, IonButton, IonSelect, IonSelectOption, IonLabel, IonItem, IonInput, IonTextarea, useIonToast } from '@ionic/react';
import { close, ticket, arrowBack, cloudUploadOutline, chevronBack, chevronForward } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { ToBase64 } from '../../../defines/Functions';
import axios from 'axios';
import Loading from '../../Loading';
import ProfileTicketDetails from './ProfileTicketDetails';
import moment from 'jalali-moment';
import './ProfileTicket.css';
import profileTicket from '../../../assets/images/dashboard-support.svg';
import warningSign from '../../../assets/images/warning.svg';
import hourGlass from '../../../assets/images/hourglass.svg';
import checkMark from '../../../assets/images/checkmark.svg';

const ProfileTicket = () => {
    const profileTicketCategories = Constants.api.profileTicketCategories;
    const profileTicketSubCategories = Constants.api.profileTicketSubCategories;
    const profileTicketAdd = Constants.api.profileTicketAdd;
    const profileTicketSearch = Constants.api.profileTicketSearch;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        });
    };
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfileTicketModal: false,
        step: 0,
        token: '',
        pagination: {
            currentPage: 1,
            pageCount: 0,
            perPage: 10,
            totalCount: 0
        },
        tickets: [],
        categories: [],
        subCategories: [],
        selectedCategory: {} as any,
        selectedSubCategory: {} as any
    });
    const [formData, setFormData] = useState({
        categoryId: 0,
        subCategoryId: 0,
        title: '',
        text: '',
        contractId: '',
        attachements: [] as any,
        status: 'N'
    });
    const [required, setRequired] = useState({
        title: { value: false, message: '' },
        contractId: { value: false, message: '' },
        text: { value: false, message: '' }

    });
    const nextStep = () => {
        setState(prevState => ({ ...prevState, step: state.step + 1 }));
    }
    const prevStep = () => {
        setState(prevState => ({ ...prevState, step: state.step - 1 }));
    }
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const getTickets = async (page: number, perPage: number) => {
        setLoading(true);
        try {
            const ticketResults = await axios.post(profileTicketSearch + '?page=' + page + '&per-page=' + perPage, null, {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (ticketResults.status === 200) {
                setState(prevState => ({
                    ...prevState,
                    tickets: ticketResults.data.items,
                    pagination: {
                        currentPage: ticketResults.data._meta.currentPage,
                        pageCount: ticketResults.data._meta.pageCount,
                        perPage: ticketResults.data._meta.perPage,
                        totalCount: ticketResults.data._meta.totalCount
                    }
                }));
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    }
    useEffect(() => {
        if (state.showProfileTicketModal) {
            getTickets(1, 10);
            const getTicketCategories = async () => {
                setLoading(true);
                try {
                    const categoryResults = await axios.get(profileTicketCategories, {
                        headers: {
                            Authorization: 'Bearer ' + state.token
                        }
                    });
                    if (categoryResults.status === 200) {
                        setState(prevState => ({ ...prevState, categories: categoryResults.data.items }));
                        setLoading(false);
                    }
                } catch (error: any) {
                    console.log(error);
                    setLoading(false);
                }
            }
            getTicketCategories();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileTicketCategories, profileTicketSearch, state.showProfileTicketModal, state.token]);
    const onCategoryClick = async (id: number, title: string) => {
        setLoading(true);
        nextStep();
        try {
            const subCategoryResults = await axios.get(profileTicketSubCategories + id, {
                headers: {
                    Authorization: 'Bearer ' + state.token
                }
            });
            if (subCategoryResults.status === 200) {
                const categoryObj = {
                    id: id,
                    title: title
                }
                setState(prevState => ({ ...prevState, subCategories: subCategoryResults.data.items, selectedCategory: categoryObj }));
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    }
    const onSubCategoryClick = (value: any) => {
        nextStep();
        setState(prevState => ({ ...prevState, selectedSubCategory: value }));
    }
    useEffect(() => {
        if (state.step === 3) {
            setFormData({ ...formData, categoryId: state.selectedCategory.id, subCategoryId: state.selectedSubCategory.id });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedCategory.id, state.selectedSubCategory.id, state.step])
    const getFile = async () => {
        const file = document.querySelector('#myfile') as any;
        if (file) {
            const fileContent = await ToBase64(file.files[0]);
            const fileName = file.files[0].name;
            setFormData(prevFromData => ({
                ...prevFromData,
                attachements: [...prevFromData.attachements, { file_name: fileName, file_content: fileContent }]
            }))
        }
    }
    const removeFile = (index: number) => {
        const formAttachments = formData.attachements;
        formAttachments.splice(index, 1);
        setFormData(prevFormData => ({ ...prevFormData, attachements: formAttachments }));
    }
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (formData.title.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, title: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, title: { value: false, message: '' } } });
        }
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
        }
        if (formData.contractId.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, contractId: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, contractId: { value: false, message: '' } } });
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (formData.title.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, title: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, title: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.contractId.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, contractId: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, contractId: { value: false, message: '' } } });
            isRequired = false;
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        const submitData = {
            support_tickets: [{
                title: formData.title,
                contract_id: formData.contractId,
                category_id: formData.categoryId,
                sub_category_id: formData.subCategoryId,
                status: 'N'
            }],
            support_tickets_replies: [{
                text: formData.text,
                attachements: formData.attachements
            }]
        }
        try {
            const formResults = await axios.post(profileTicketAdd, JSON.stringify(submitData), {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.result === 'error') {
                setFormData({
                    ...formData,
                    title: '',
                    text: '',
                    contractId: '',
                    attachements: []
                });
                showToast({ message: formResults.data.message, color: 'danger' });
                setLoading(false);
            } else {
                setFormData({
                    ...formData,
                    title: '',
                    text: '',
                    contractId: '',
                    attachements: []
                });
                showToast({ message: formResults.data.message, color: 'success' });
                setState({ ...state, step: 0 });
                getTickets(state.pagination.currentPage, state.pagination.perPage);
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    const nextPage = () => {
        getTickets(state.pagination.currentPage + 1, 10);
        setState({ ...state, pagination: { ...state.pagination, currentPage: state.pagination.currentPage + 1 } });
    }
    const prevPage = () => {
        getTickets(state.pagination.currentPage - 1, 10);
        setState({ ...state, pagination: { ...state.pagination, currentPage: state.pagination.currentPage - 1 } });
    }
    return (
        <>
            <IonModal isOpen={state.showProfileTicketModal} onDidDismiss={() => setState({ ...state, showProfileTicketModal: false })} mode="ios" cssClass="profile-ticket-modal">
                <div className="profile-ticket-modal-content">
                    <h3 className="profile-ticket-modal-title">
                        پشتیبانی
                        <IonIcon icon={close} onClick={() => setState({ ...state, showProfileTicketModal: false })} />
                    </h3>
                    {state.step === 0 ?
                        <>
                            <div className="step-title">
                                <b>درخواست‌های پشتیبانی</b>
                                <p>
                                    اگر نیاز به کمک دارید برای سوال یا مشکل خود یک تیکت جدید ایجاد کنید.
                                </p>
                                <IonButton color="warning" expand="block" className="add-ticket-btn" onClick={nextStep}>
                                    ایجاد تیکت
                                    <IonIcon icon={ticket} />
                                </IonButton>
                            </div>
                            <div className="profile-ticket-modal-items">
                                {state.tickets.length === 0 ?
                                    <div className="box-error">
                                        <IonImg src={warningSign} />
                                        <p>در حال حاضر هیچ تیکتی ثبت نشده است</p>
                                    </div>
                                    :
                                    <>
                                        <div className="status-hint">
                                            <b>وضعیت : </b>
                                            <span>
                                                منتظر پاسخ پشتیبان
                                                <IonImg src={hourGlass} />
                                            </span>
                                            <span>
                                                تایید پاسخ پشتیبان
                                                <IonImg src={checkMark} />
                                            </span>
                                        </div>
                                        <IonGrid>
                                            <IonRow>
                                                <IonCol size="2">
                                                    شماره
                                                </IonCol>
                                                <IonCol size="2">
                                                    نوع
                                                </IonCol>
                                                <IonCol size="2">
                                                    عنوان
                                                </IonCol>
                                                <IonCol size="2">
                                                    وضعیت
                                                </IonCol>
                                                <IonCol size="2">
                                                    بروزرسانی
                                                </IonCol>
                                                <IonCol size="2">
                                                    عملیات
                                                </IonCol>
                                            </IonRow>
                                            {state.tickets.map((item: any, index: number) =>
                                                <IonRow key={"index" + index}>
                                                    <IonCol size="2">
                                                        #{item.ticket.id}
                                                    </IonCol>
                                                    <IonCol size="2">
                                                        {item.ticket.category_id.title}
                                                    </IonCol>
                                                    <IonCol size="2">
                                                        <span className="text-line-limit limit-2">
                                                            {item.ticket.sub_category_id.title}
                                                        </span>
                                                    </IonCol>
                                                    <IonCol size="2">
                                                        {item.ticket.status === 'N' ?
                                                            <IonImg src={hourGlass} />
                                                            :
                                                            <IonImg src={checkMark} />
                                                        }
                                                    </IonCol>
                                                    <IonCol size="2">
                                                        {moment(item.ticket.modified_datetime).locale('fa').format("YYYY/MM/DD HH:MM:s")}
                                                    </IonCol>
                                                    <IonCol size="2" className="action-btns">
                                                        <ProfileTicketDetails ticketId={item.ticket.id} />
                                                    </IonCol>
                                                </IonRow>
                                            )}
                                        </IonGrid>
                                        <div className="my-custom-pagination">
                                            <span>صفحه {state.pagination.currentPage} از {state.pagination.pageCount}</span>
                                            {state.pagination.pageCount > 1 &&
                                                <ul>
                                                    <li onClick={prevPage} className={state.pagination.currentPage === 1 ? 'disabled' : ''}>
                                                        <IonIcon icon={chevronForward} />
                                                    </li>
                                                    <li onClick={nextPage} className={state.pagination.currentPage === state.pagination.pageCount ? 'disabled' : ''}>
                                                        <IonIcon icon={chevronBack} />
                                                    </li>
                                                </ul>
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                        </>
                        : state.step === 1 ?
                            <>
                                <div className="step-title can-back">
                                    <span className="prev-step" onClick={prevStep}>
                                        بازگشت
                                        <IonIcon icon={arrowBack} />
                                    </span>
                                    <b>لطفا برمبنای خدماتی که خریداری کرده‌اید یا سوال دارید دسته بندی مورد نظر خود را انتخاب کنید.</b>
                                    <p>
                                        دسته‌بندی به ما کمک می‌کند که در کمترین زمان ممکن سوال شما را توسط متخصص آن حوزه پاسخ دهیم.
                                    </p>
                                </div>
                                {!loading ?
                                    <div className="step-categories">
                                        <IonGrid>
                                            <IonRow>
                                                {state.categories.map((item: any, index: number) =>
                                                    item.status === 'T' &&
                                                    <IonCol size="6" key={"index" + index}>
                                                        <div className="step-category-box" onClick={() => onCategoryClick(item.id, item.title)}>
                                                            <IonImg src={Constants.uploads + 'support_categories/' + item.image} />
                                                            {item.title}
                                                        </div>
                                                    </IonCol>
                                                )}
                                            </IonRow>
                                        </IonGrid>
                                    </div>
                                    :
                                    <Loading />
                                }
                            </>
                            : state.step === 2 ?
                                <>
                                    <div className="step-title can-back">
                                        <span className="prev-step" onClick={prevStep}>
                                            بازگشت
                                            <IonIcon icon={arrowBack} />
                                        </span>
                                        <b>نوع درخواست خود را انتخاب نمایید</b>
                                    </div>
                                    {!loading ?
                                        <div className="step-subcategores">
                                            <IonLabel>
                                                <b>
                                                    نوع درخواست
                                                </b>
                                            </IonLabel>
                                            <IonItem lines="none">
                                                <IonLabel>نوع درخواست</IonLabel>
                                                <IonSelect
                                                    mode="md"
                                                    okText="تایید"
                                                    cancelText="لغو"
                                                    onIonChange={e => onSubCategoryClick(e.detail.value)}
                                                >
                                                    {state.subCategories.map((item: any, index: number) =>
                                                        item.category.status === 'T' &&
                                                        <IonSelectOption key={"index" + index} value={{ id: item.category.id, title: item.category.title }}>
                                                            {item.category.title}
                                                        </IonSelectOption>
                                                    )}
                                                </IonSelect>
                                            </IonItem>
                                        </div>
                                        :
                                        <Loading />
                                    }
                                </>
                                :
                                <>
                                    <div className="step-title can-back">
                                        <span className="prev-step" onClick={prevStep}>
                                            بازگشت
                                            <IonIcon icon={arrowBack} />
                                        </span>
                                        <p>به درخواست های شما طی نهایتا ۲۴ ساعت کاری پاسخ داده خواهد شد. توضیح کامل و جامع‌تر شما باعث سریعتر پاسخ داده شدن درخواست می‌شود.</p>
                                    </div>
                                    <div className="profile-ticket-modal-input-container">
                                        {!loading ?
                                            <form onSubmit={handleSubmit}>
                                                <IonGrid>
                                                    <IonRow>
                                                        <IonCol size="12">
                                                            <IonLabel>
                                                                دسته بندی درخواست
                                                            </IonLabel>
                                                            <IonInput type="text" value={state.selectedCategory.title ? state.selectedCategory.title : ''} readonly />
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <IonLabel>
                                                                نوع درخواست
                                                            </IonLabel>
                                                            <IonInput type="text" value={state.selectedSubCategory.title ? state.selectedSubCategory.title : ''} readonly />
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <IonLabel>
                                                                عنوان درخواست
                                                                {required.title.value ? <span className="required">{required.title.message}</span> : null}
                                                            </IonLabel>
                                                            <IonInput type="text" name="title" value={formData.title || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur} />
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <IonLabel>
                                                                متن درخواست
                                                                {required.text.value ? <span className="required">{required.text.message}</span> : null}
                                                            </IonLabel>
                                                            <IonTextarea rows={7} name="text" value={formData.text || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur}>
                                                            </IonTextarea>
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <IonLabel>
                                                                شماره قرارداد
                                                                {required.contractId.value ? <span className="required">{required.contractId.message}</span> : null}
                                                            </IonLabel>
                                                            <IonInput type="text" name="contractId" value={formData.contractId || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur} />
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <label className="file-uploader">
                                                                <IonIcon icon={cloudUploadOutline} />
                                                                <span>فایل خود را آپلود کنید</span>
                                                                <input type="file" hidden id="myfile" onChange={getFile} accept="image/*,.pdf,.zip" />
                                                            </label>
                                                            {formData.attachements.length !== 0 &&
                                                                <div className="file-preview">
                                                                    <IonGrid>
                                                                        <IonRow>
                                                                            {formData.attachements.map((item: any, index: number) =>
                                                                                <IonCol size="4" key={"index" + index}>
                                                                                    <div className="file-preview-item">
                                                                                        <IonIcon icon={close} onClick={() => removeFile(index)} />
                                                                                        <span>{item.file_name}</span>
                                                                                    </div>
                                                                                </IonCol>
                                                                            )}
                                                                        </IonRow>
                                                                    </IonGrid>
                                                                </div>
                                                            }
                                                        </IonCol>
                                                        <IonCol size="12">
                                                            <IonButton type="submit" color="warning" expand="block">
                                                                ثبت درخواست
                                                            </IonButton>
                                                        </IonCol>
                                                    </IonRow>
                                                </IonGrid>
                                            </form>
                                            :
                                            <Loading />
                                        }
                                    </div>
                                </>
                    }
                </div>
            </IonModal>
            <div className="dashboard-box" onClick={() => setState({ ...state, showProfileTicketModal: true })}>
                <div>
                    <IonImg src={profileTicket} />
                </div>
                <div>
                    <b>پشتیبانی</b>
                </div>
            </div>
        </>
    );
};
export default ProfileTicket;